const LandingPageMobileDisplay = () => import(/* webpackPrefetch: true, webpackChunkName: "landing-page-mobile-display" */ '@/app/views/client-view/landing-page/components/_shared/landing-page-mobile-display/landing-page-mobile-display.vue');

export default {
    name: 'LandingPageFeatures',
    components: {
        LandingPageMobileDisplay
    },
    data() {
        return {
            leftColumnOriginal: [
                {
                    title: 'My Pet Info',
                    description: 'Breed specific health tips including preventative health information, store your pet documentation, and set reminders.',
                    imageName: 'gen-info.png'
                },
                {
                    title: 'Social Club',
                    description: 'Automatically become a member of our social groups create your own group share images and information.',
                    imageName: 'social-club-icon.png'
                },
                {
                    title: 'Flea/Worm',
                    description: 'Automatic alerts when to apply Flea/Worm/Tick, for multiple brands and hundreds of treatments also keep a log of all treatments applied to your dog.',
                    imageName: 'treatment.png'
                }
            ],
            leftColumn: [],
            rightColumn: [
                {
                    title: 'Shop',
                    description: 'Purchase products for your dog, only see products for your breed and age of dog.',
                    imageName: 'shop.png'
                },
                {
                    title: 'Exercise',
                    description: 'Set exercise requirements for your dog and use the app to monitor and log exercise details.',
                    imageName: 'health-data.png'
                },
                {
                    title: 'Walker/Sitter',
                    description: 'Find a dog sitter for your dog, using our matching tool. Match a sitter or walker that can home your dog when you are away.',
                    imageName: 'walker-sitter-icon.png'
                }
            ],
            imgUrl: require('@/assets/images/_shared/app-screenshots/home-screen.png')
        }
    },
    beforeDestroy() {
        $(window).off('resize')
    },
    mounted() {
        this.leftColumn = this.leftColumnOriginal
        this.transferRightColumnToLeft()
        $(window).on('resize', () => this.transferRightColumnToLeft())
    },
    methods: {
        isMobile() {
            return screen.width <= 1180
        },
        transferRightColumnToLeft () {
            if (this.isMobile()) {
                if (this.leftColumn.length === 3 && this.leftColumn.length !== 6) {
                    this.leftColumn = [...this.leftColumnOriginal, ...this.rightColumn]
                }
            } else {
                this.leftColumn = this.leftColumnOriginal
            }
        }
    }
}